import React, { useState } from "react";
import ModalWrap from "./ModalWrap";
import { TextField, Typography } from "@mui/material";
import "./emailchange.scss";
import { changeEmailInfo } from "../../services/websiteApi";
import { userInfoFetch } from "../../utlis/commonFunction";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../state/actions/globalAction";
import { pageLocale } from "../../utlis/locale";

const EmailChange = ({ emailPopUp, setEmailPopup }) => {
  const dispatch = useDispatch();
  const email = emailPopUp?.data?.value;
  const [updatedEmail, setUpdatedEmail] = useState(null);
  const name = emailPopUp?.data?.name;
  const emailUpdateHandler = (e) => {
    setUpdatedEmail(e.target.value);
  };
  const { save, cancel } = pageLocale("common");
  const request = {
    data: [
      {
        widget_id: "REPORT_SHARE_WIDGET",
        name,
        uniqueId: emailPopUp?.data?.uniqueId,
        value: updatedEmail,
      },
    ],
  };

  const closeHandler = () => {
    setEmailPopup({ ...emailPopUp, state: false });
  };

  const emailChangeHandler = () => {
    dispatch(setAPILoader(true));
    changeEmailInfo(request, userInfoFetch()?.id, name)
      .then(() => {
        dispatch(setAPILoader(false));
        emailPopUp.data.value = updatedEmail;
        closeHandler();
      })
      .catch(() => {
        dispatch(setAPILoader(false));
        closeHandler();
      });
  };

  const isvalidemailCheckHandler = () => {
    if (updatedEmail === null) {
      return true;
    }
    if (updatedEmail === email) {
      return true;
    }
    if (!/(.+)@(.+){2,}\.(.+){2,}/.test(updatedEmail)) {
      return true;
    }
    return false;
  };
  return (
    <ModalWrap
      className="email-change-wrapper"
      open={emailPopUp?.state}
      onClose={closeHandler}
    >
      <div className="email-change-info">
        <Typography className="destination-type">{name}</Typography>
        <TextField
          label="Email"
          className="email"
          defaultValue={email}
          onChange={(e) => emailUpdateHandler(e)}
        />
        <button
          className="save-btn"
          onClick={() => emailChangeHandler()}
          disabled={isvalidemailCheckHandler()}
        >
          {save}
        </button>
        <button className="cancel-btn" onClick={closeHandler}>
          {cancel}
        </button>
      </div>
    </ModalWrap>
  );
};

export default EmailChange;
